var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"iframe-wrapper"},[_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.fullSrc,"frameborder":"0","name":"target","crossorigin":"*"}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }